import { ZoneMasterThemeModeConfig } from './types';

const light: ZoneMasterThemeModeConfig = {
  zoneMaster: {},
};

export default light;
